import {
  KnownCurrentActionDtoType,
  KnownTimelineEventDtoNotificationStatus,
  KnownTimelineEventDtoType
} from '@groundfloor-platform/mgmt-service-g-sdk';
import { EventDoor } from '../../../../../ui/components/pure/icons/EventDoor.icon';
import { EventDoorJammed } from '../../../../../ui/components/pure/icons/EventDoorJammed.icon';
import { EventDoorSwitched } from '../../../../../ui/components/pure/icons/EventDoorSwitched.icon';
import { StatusBooked } from '../../../../../ui/components/pure/icons/StatusBooked.icon';
import { StatusCancelled } from '../../../../../ui/components/pure/icons/StatusCancelled.icon';
import { StatusCollected } from '../../../../../ui/components/pure/icons/StatusCollected.icon';
import { StatusDeleted } from '../../../../../ui/components/pure/icons/StatusDeleted.icon';
import { StatusDelivered } from '../../../../../ui/components/pure/icons/StatusDelivered.icon';
import { StatusInProgress } from '../../../../../ui/components/pure/icons/StatusInProgess.icon';
import { StatusOverdue } from '../../../../../ui/components/pure/icons/StatusOverdue.icon';
import { StatusRetrievalRequired } from '../../../../../ui/components/pure/icons/StatusRetrievalRequired.icon';
import { StatusRetrieved } from '../../../../../ui/components/pure/icons/StatusRetrieved.icon';
import { StatusUndoCancel } from '../../../../../ui/components/pure/icons/StatusUndoCancel.icon';
import { SVGIconComponent } from '../../../../../ui/components/pure/icons/types';
import { Colors } from '../../../../../ui/theme/colors';
import { Note } from '../../../../../ui/components/pure/icons/Note.icon';
import { StatusWarning } from '../../../../../ui/components/pure/icons/StatusWarning.icon';
import { AccessLocked } from '../../../../../ui/components/pure/icons/AccessLocked.icon';
import { AccessUnlocked } from '../../../../../ui/components/pure/icons/AccessUnlocked.icon';
import { LockerEnabled } from '../../../../../ui/components/pure/icons/LockerEnabled.icon';
import { EventAllocated } from '../../../../../ui/components/pure/icons/EventAllocated.icon';

export const notificationColors: Record<KnownTimelineEventDtoNotificationStatus, string> = {
  enroute: Colors.bookedScannedInProgressGray,
  delayed: Colors.overdueOrange,
  successful: Colors.collectedGreen,
  failed: Colors.cancelledDeletedRed
};

export const eventIcons: Record<KnownCurrentActionDtoType | KnownTimelineEventDtoType, SVGIconComponent | undefined> = {
  'ac-migration': undefined,
  'action-collect': StatusCollected,
  'notification-update': undefined,
  'notification-manual': undefined,
  'notification-reminder': undefined,
  'status-inprogress': StatusInProgress,
  'status-delivered': StatusDelivered,
  'delivery-lodged': StatusDelivered,
  'status-overdue': StatusOverdue,
  'status-collected': StatusCollected,
  'status-cancelled': StatusCancelled,
  'status-deleted': StatusDeleted,
  'door-switched': EventDoorSwitched,
  'door-jammed': EventDoorJammed,
  'door-opened': EventDoor,
  'status-booked': StatusBooked,
  'action-deliver': StatusDelivered,
  'status-retrievalrequested': StatusRetrievalRequired,
  'action-retrievecancelled': StatusRetrieved,
  'status-retrieved': StatusRetrieved,
  'undo-cancellation': StatusUndoCancel,
  'note-created': Note,
  'handoff-failed': StatusDeleted,
  'handoff-retrieval-failed': StatusDeleted,
  'status-override': undefined,
  'kiosk-failure': StatusWarning,
  'no-delivery-containers-available': StatusWarning,
  'access-failed': AccessLocked,
  'access-granted': AccessUnlocked,
  'locker-allocated': EventAllocated,
  'note-updated': Note,
  'delivery-container-opened': EventDoor,
  'delivery-container-enabled': LockerEnabled,
  'delivery-container-disabled': StatusWarning
};
